export const INITIAL_VALUES = {
  email: '',
  organisation: '',
  person: '',
  phone: '',
};
